const repairApplyNewFormConf = {
  size: 'medium',
  span: 24,
  fields: [
    {
      type: 'default',
      align: 'top',
      justify: 'start',
      __config__: {
        span: 24,
        formId: 'row_repair_apply_new',
        layout: 'rowFormItem',
        tagIcon: 'row',
        children: [
          {
            style: { width: '100%' },
            __slot__: { append: '', suffix: '', prepend: '' },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '联系人',
              formId: 'contacts',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'contacts',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'contacts',
            placeholder: '请输入联系人',
            __readonly__: { span: 1 },
            'show-word-limit': false,
          },
          {
            style: { width: '100%' },
            __slot__: { append: '', suffix: '', prepend: '' },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '联系电话',
              formId: 'telephone',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'telephone',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'telephone',
            placeholder: '请输入联系电话',
            __readonly__: { span: 1 },
            'show-word-limit': false,
          },
          {
            style: { width: '100%' },
            options: [],
            disabled: false,
            readonly: false,
            __config__: {
              tag: 'el-tree-select',
              _tag: 'a-tree-select',
              span: 24,
              label: '站点名称',
              formId: 'abodeName',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'tree',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'abodeName',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'abodeName',
            placeholder: '请选择站点',
            __readonly__: { span: 1 },
          },
          {
            style: { width: '100%' },
            __slot__: { append: '', suffix: '', prepend: '' },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '用户姓名',
              formId: 'name',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'name',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'name',
            placeholder: '请输入',
            __readonly__: { span: 1 },
            'show-word-limit': false,
          },
          {
            style: { width: '100%' },
            __slot__: { append: '', suffix: '', prepend: '' },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '报修区域',
              formId: 'address',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'address',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'address',
            placeholder: '请选择',
            __readonly__: { span: 1 },
            'show-word-limit': false,
          },
          {
            style: { width: '100%' },
            __slot__: { append: '', suffix: '', prepend: '' },
            disabled: false,
            readonly: false,
            clearable: true,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '报修详细地址',
              formId: 'addressDetail',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'input',
              required: true,
              showItem: true,
              changeTag: true,
              renderKey: 'addressDetail',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'addressDetail',
            placeholder: '请输入报修详细地址',
            __readonly__: { span: 1 },
            'show-word-limit': false,
          },
          {
            type: 'textarea',
            style: { width: '100%' },
            autosize: { maxRows: 4, minRows: 4 },
            disabled: false,
            readonly: false,
            __config__: {
              tag: 'el-input',
              _tag: 'a-input',
              span: 24,
              label: '报事报修内容',
              formId: 'explain',
              layout: 'colFormItem',
              regList: [{ message: '不低于3个字', pattern: '/^.{3,}$/' }],
              tagIcon: 'textarea',
              required: false,
              showItem: true,
              changeTag: true,
              renderKey: 'explain',
              showLabel: true,
              renderItem: true,
              defaultValue: '',
            },
            __vModel__: 'explain',
            placeholder: '请输入报事报修内容',
            __readonly__: { span: 1 },
            'show-word-limit': false,
          },
          {
            name: 'file',
            accept: 'image/*',
            __slot__: { 'list-type': true },
            disabled: false,
            multiple: true,
            'list-type': 'text',
            __config__: {
              tag: 'el-upload',
              _tag: 'a-upload',
              span: 24,
              label: '图片上传',
              formId: 'images',
              layout: 'colFormItem',
              regList: [],
              tagIcon: 'upload',
              fileSize: 5,
              required: true,
              showItem: true,
              sizeUnit: 'MB',
              changeTag: true,
              renderKey: 'images',
              showLabel: true,
              buttonText: '点击上传',
              renderItem: true,
            },
            __vModel__: 'images',
            buttonText: '',
            'auto-upload': true,
            placeholder: '请上传图片',
            __readonly__: { span: 1 },
            uploadNumber: 5,
          },
        ],
        renderKey: 'row_repair_apply_new',
        layoutTree: true,
        componentName: 'row_repair_apply_new',
      },
    },
  ],
  formRef: 'elForm',
  formModel: 'formData',
  labelPosition: 'right',
  labelWidth: 120,
  formRules: 'rules',
  gutter: 15,
  disabled: false,
  formBtns: true,
  readonly: false,
};

function cloneFormConf() {
  return JSON.parse(JSON.stringify(repairApplyNewFormConf));
}

export function getRepairApplyNewFormConf(abodeList = []) {
  const formConf = cloneFormConf();
  const fields = formConf.fields[0].__config__.children;
  const abodeField = fields.find((field) => field.__vModel__ === 'abodeName');

  if (abodeField) {
    abodeField.options = abodeList;
  }

  formConf.__methods__ = {
    change(event) {
      if (
        event &&
        typeof event === 'object' &&
        event.value !== undefined &&
        this.$parent &&
        typeof this.$parent.handleTreeSelectChange === 'function'
      ) {
        this.$parent.handleTreeSelectChange(event);
      }
    },
  };

  return formConf;
}

export default getRepairApplyNewFormConf;
